/*=========================================================================================
File Name: router.js
Description: Routes for vue-router. Lazy loading is enabled.
Object Strucutre:
path => router path
name => router name
component(lazy loading) => component to load
meta : {
rule => which user can have access (ACL)
breadcrumb => Add breadcrumb to specific page
pageTitle => Display title besides breadcrumb
}
----------------------------------------------------------------------------------------
Item Name: Vuesax Admin - VueJS Dashboard Admin Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'dashboard',
          component: () => import('./views/Home.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', active: true }
            ],
            rule: 'utente',
            title: 'Dashboard - Cedascom',
          }
        },
        {
          path: '/aziende',
          name: 'aziende',
          component: () => import('./views/azienda/Aziende.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Aziende', active: true },
            ],
            pageTitle: 'Aziende',
            title: 'Aziende - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/utenti',
          name: 'utenti',
          component: () => import('./views/utente/Utenti.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Utenti', active: true },
            ],
            pageTitle: 'Utenti',
            title: 'Utenti - Cedascom',
            rule: 'admin'
          },
        },
        {
          path: '/documenti/preventivi',
          name: 'documenti-preventivi',
          component: () => import('./views/documenti/Preventivi.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documenti' },
              { title: 'Preventivi', active: true },
            ],
            pageTitle: 'Preventivi',
            title: 'Preventivi - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/documenti/contratti',
          name: 'documenti-contratti',
          component: () => import('./views/documenti/Contratti.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documenti' },
              { title: 'Contratti', active: true },
            ],
            pageTitle: 'Contratti',
            title: 'Contratti - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/documenti/altri',
          name: 'documenti-altri',
          component: () => import('./views/documenti/Altri.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documenti' },
              { title: 'Altri', active: true },
            ],
            pageTitle: 'Altri Documenti',
            title: 'Altri - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/documenti/rimborsi/:wanted_id?',
          name: 'documenti-rimborsi',
          component: () => import('./views/rimborsi/Rimborsi.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documenti' },
              { title: 'Rimborsi', active: true },
            ],
            pageTitle: 'Rimborsi',
            title: 'Rimborsi - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/documenti/addebiti/:wanted_id?',
          name: 'documenti-addebiti',
          component: () => import('./views/addebiti/Addebiti.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Documenti' },
              { title: 'Addebiti', active: true },
            ],
            pageTitle: 'Addebiti',
            title: 'Addebiti - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/leads/elenco',
          name: 'leads-elenco',
          component: () => import('./views/boards/TableLeads.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Leads', active: true },
              { title: 'Elenco', active: true },
            ],
            pageTitle: 'Leads',
            title: 'Leads - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/leads/board',
          name: 'leads-board',
          component: () => import('./views/boards/BoardLeads.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Leads', active: true },
              { title: 'Board', active: true },
            ],
            pageTitle: 'Leads',
            title: 'Leads - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/tariffario',
          name: 'tariffario',
          component: () => import('./views/tariffario/Tariffario.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tariffario', active: true },
            ],
            pageTitle: 'Tariffario',
            title: 'Tariffario - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/pacchetti',
          name: 'pacchetti',
          component: () => import('./views/pacchetti/Pacchetti.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Altro', active: true },
              { title: 'Pacchetti', active: true },
            ],
            pageTitle: 'Pacchetti',
            title: 'Pacchetti - Cedascom',
            rule: 'admin'
          },
        },
        {
          path: '/templates',
          name: 'templates',
          component: () => import('./views/template/Template.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Altro', active: true },
              { title: 'Template', active: true },
            ],
            pageTitle: 'Templates',
            title: 'Templates - Cedascom',
            rule: 'admin'
          },
        },
        {
          path: '/default_templates',
          name: 'default_templates',
          component: () => import('./views/template/DefaultTemplatesTable.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Altro', active: true },
              { title: 'Default Templates', active: true },
            ],
            pageTitle: 'Templates',
            title: 'Templates - Cedascom',
            rule: 'admin'
          },
        },
        {
          path: '/contatti',
          name: 'contatti',
          component: () => import('./views/azienda/Contatti.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Contatti', active: true },
            ],
            pageTitle: 'Contatti',
            title: 'Contatti - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/attivita/elenco',
          name: 'attivita-elenco',
          component: () => import('./views/attivita/TableAttivita.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Attività', active: true },
              { title: 'Elenco', active: true },
            ],
            pageTitle: 'Attività',
            title: 'Attività - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/attivita/calendario',
          name: 'attivita-calendario',
          component: () => import('./views/attivita/Calendar.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Attività', active: true },
              { title: 'Calendario', active: true },
            ],
            pageTitle: 'Attività',
            title: 'Attività - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/tirocini/pratiche',
          name: 'tirocini-pratiche',
          component: () => import('./views/tirocini/PraticheTirocini.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tirocini' },
              { title: 'Pratiche', active: true },
            ],
            pageTitle: 'Tirocini',
            title: 'Tirocini - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/tirocini/tutor',
          name: 'tirocini-tutor',
          component: () => import('./views/tirocini/TutorTirocini.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tirocini' },
              { title: 'Tutor', active: true },
            ],
            pageTitle: 'Tutor Tirocini',
            title: 'Tutor Tirocini - Cedascom',
            rule: 'utente'
          },
        },
        {
          path: '/todo',
          name: 'to-do',
          component: () => import('./views/utente/Todo.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'To-Do', active: true },
            ],
            pageTitle: 'To Do',
            title: 'To Do - Cedascom',
            rule: 'utente'
          },
        },
        // {
        //   path: '/reports',
        //   name: 'reports',
        //   component: () => import('./views/reports/Reports.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Reports', active: true },
        //     ],
        //     pageTitle: 'Reports',
        //     title: 'Report - Cedascom',
        //     rule: 'admin'
        //   },
        // },
        // {
        //   path: '/reports/mappa',
        //   name: 'reports-mappa',
        //   component: () => import('./views/reports/Map.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Reports' },
        //       { title: 'Mappa', active: true },
        //     ],
        //     pageTitle: 'Reports',
        //     title: 'Reports - Cedascom',
        //     rule: 'admin'
        //   },
        // },
        {
          path: '/reports/dati',
          name: 'reports-dati',
          component: () => import('./views/reports/Data.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reports' },
              { title: 'Dati', active: true },
            ],
            pageTitle: 'Reports',
            title: 'Reports - Cedascom',
            rule: 'responsabile'
          },
        },
        // {
        //   path: '/reports/dati-benchmark',
        //   name: 'reports-dati-benchmark',
        //   component: () => import('./views/reports/benchmark/Dati.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Reports' },
        //       { title: 'Dati Benchmark', active: true },
        //     ],
        //     pageTitle: 'Reports',
        //     title: 'Reports - Cedascom',
        //     rule: 'admin'
        //   },
        // },
        // {
        //   path: '/reports/stats',
        //   name: 'reports-stats',
        //   component: () => import('./views/reports/Stats.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Reports' },
        //       { title: 'Statistiche', active: true },
        //     ],
        //     pageTitle: 'Reports',
        //     title: 'Reports - Cedascom',
        //     rule: 'admin'
        //   },
        // },
        // {
        //   path: '/reports/mappa',
        //   name: 'reports-mappa',
        //   component: () => import('./views/reports/benchmark/Mappa.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Reports' },
        //       { title: 'Mappa', active: true },
        //     ],
        //     pageTitle: 'Reports',
        //     title: 'Reports - Cedascom',
        //     rule: 'admin'
        //   },
        // },
        // {
        //   path: '/reports/dati',
        //   name: 'reports-dati',
        //   component: () => import('./views/reports/benchmark/Dati.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Reports' },
        //       { title: 'Dati', active: true },
        //     ],
        //     pageTitle: 'Reports',
        //     title: 'Reports - Cedascom',
        //     rule: 'admin'
        //   },
        // },
        // {
        //   path: '/reports/stats',
        //   name: 'reports-stats',
        //   component: () => import('./views/reports/benchmark/Report.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'Home', url: '/' },
        //       { title: 'Reports' },
        //       { title: 'Statistiche', active: true },
        //     ],
        //     pageTitle: 'Reports',
        //     title: 'Reports - Cedascom',
        //     rule: 'admin'
        //   },
        // },
        {
          path: '/faq',
          name: 'faq',
          component: () => import('./views/pages/faq.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'FAQ', active: true },
            ],
            pageTitle: 'FAQ',
            title: 'FAQ - Cedascom',
            rule: 'utente'
          },
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/tirocinio/:token',
          name: 'modulo-tirocinio',
          component: () => import('@/views/tirocini/ModuloTirocinio.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/tirocinio/show/:token',
          name: 'pub-show-tirocinio',
          component: () => import('@/views/tirocini/PubShowTirocinio.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/preventivo/:token',
          name: 'rifiuta-preventivo',
          component: () => import('@/views/documenti/RifiutaPreventivo.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/contratto/:token',
          name: 'confirm-contratto',
          component: () => import('@/views/documenti/ConfirmContratto.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/login',
          name: 'pageLogin',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'pageForgotPassword',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/reset-password',
          name: 'pageResetPassword',
          component: () => import('@/views/pages/ResetPassword.vue'),
          props: true,
          meta: {
            rule: 'public'
          }
        },
        {
          path: '/pages/error-404',
          name: 'pageError404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'public'
          }
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach((to) => {
  const DEFAULT_TITLE = 'Cedascom';
  document.title = to.meta.title || DEFAULT_TITLE;
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

let roles = {
  0: 'admin',
  // 1: 'lieutenant',
  1: 'responsabile',
  2: 'utente'
}

router.beforeEach((to, from, next) => {
  // console.log("Want to access to resource: ", to);
  if (
    to.name === "modulo-tirocinio" ||
    to.name === "pub-show-tirocinio" ||
    to.name === "rifiuta-preventivo" ||
    to.name === "confirm-contratto" ||
    to.name === "pageLogin" ||
    to.path === "/pages/forgot-password" ||
    to.path === "/pages/reset-password" ||
    to.path === "/pages/error-404" ||
    to.path === "/pages/error-500" ||
    to.path === "/callback" ||
    to.path === "/pages/comingsoon"
  ) {
    return next();
  }
  // console.log("Need to check authentication");

  axios.get(process.env.VUE_APP_BACKEND_API+'/auth/test', {
    headers: {
      "Access-Control-Allow-Origin": "*"
    }, withCredentials: true
  }).then(res => {
    if(res.status < 400) {
      // console.log('Valid request', res.data.message);
      // console.log(res.data.user);
      router.app.$acl.change(roles[res.data.user.permessi])
      router.app.$store.dispatch('updateUserRole', roles[res.data.user.permessi])
      localStorage.clear()
      localStorage.utente_nome = res.data.user.nome
      localStorage.utente_cognome = res.data.user.cognome
      localStorage.utente_mail = res.data.user.email
      localStorage.utente_id = res.data.user.id
      localStorage.utente_permessi = res.data.user.permessi
      localStorage.utente_todos = res.data.user.todos
      localStorage.utente_tour = res.data.user.tour
      // Bacino utenti - responsabile
      localStorage.setItem('utente_bacino',JSON.stringify(res.data.user.bacino))
  // readable as array/object by JSON.parse(localStorage.utente_bacino)
      // Rimborsi
      localStorage.setItem('deep_settings',JSON.stringify(res.data.user.deep_settings))

  // SET INITIAL SYNC TIMEOUT
      if (!router.app.$store.state.syncTimeout && localStorage.utente_mail != 'test@test.com') {
        router.app.$store.dispatch('resetSyncTimeout')
        router.app.$store.dispatch('setSyncTimeout', 300)
      }
      if (!router.app.$store.state.activeTimeout) router.app.$store.dispatch('timerSyncTimeout')

      return next();
    }
    console.log("Go to login page");
    router.push({ path: '/pages/login', query: { to: to.path } })
  }).catch(() => router.push({ path: '/pages/login', query: { to: to.path } }))

  // Specify the current path as the customState parameter, meaning it
  // will be returned to the application after auth
  // auth.login({ target: to.path });
});

export default router
